require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-flying-for-biodiversity.json") })
        }
      }, "path---projecten-flying-for-biodiversity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-flying-for-biodiversity!./.cache/json/projecten-flying-for-biodiversity.json
// module id = 415
// module chunks = 231608221292675